<script>


export default {
  name: "uConnectCheckUserDialog",
  data() {
    return {

    }
  },
  methods: {

    handleClose() {
      this.$emit('onClose');

    },
    goToUConnect() {
      // this will automatically go to the search page,if they are logged in. if they aren't logged in, the page will automatically redirect to the log in page
      window.open(
          `${process.env.VUE_APP_UNIFI_AGENT}#/uconnect/search/results`
      );

    },
  },
  props: {
    alertDialogVisible: {value : Boolean, default: false},
    dialogBoxTitle: {value : String, default: ''},
    dialogBoxMessage: {value : String, default: ''},
    userTypeErrorCode: {value : String, default: ''},
  }

}
</script>

<template>
  <el-dialog
          :before-close="handleClose"
          :visible.sync="alertDialogVisible"
          center
          style="margin: 10% 0; font-family: DINosaur-a; color: #003333"
          :title="dialogBoxTitle"
          width="100%"
      >
        <template v-if="userTypeErrorCode === 70000">
           <span class="forgotPasswordSpan"
           >{{this.dialogBoxMessage}}. Please login.</span>

        </template>
        <template v-else-if="userTypeErrorCode === 60001">
                    <span class="forgotPasswordSpan"
                          v-html="dialogBoxMessage" >{{this.dialogBoxMessage}}. Please check your junk mail to ensure you receive
                      it.</span>
        </template>
        <el-row :gutter="20" style="margin-top: 20px">
          <el-col :span="12" :offset="userTypeErrorCode === 70000 ? 0 : 12">
            <el-button
                class="dialog-footer-btn"
                type="primary"
                @click="handleClose"
            >Close</el-button
            >
          </el-col>
          <template v-if="userTypeErrorCode === 70000">
            <el-col :span="12">
              <el-button
                  class="dialog-footer-btn"
                  type="primary"
                  @click="goToUConnect"
              >Sign in to U-Connect</el-button>
            </el-col>
          </template>
        </el-row>
      </el-dialog>


</template>

<style scoped>
.promo-container {
  font-family: 'Arial', sans-serif;
  margin: 0 auto;
  padding: 40px;
  text-align: center;
  background-color: #003333;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

h1 {
  color: #ffffff;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 20px;
  line-height: 1.3;
}

.subtitle {
  color: #ffffff;
  font-size: 18px;
  margin-bottom: 30px;
}

.email-input-wrapper {
  position: relative;
  background-color: #ffffff ;
  border-radius: 18px;
}
.signup-button {
  position: absolute;
  right: 4px;
  top: 4px;
  bottom: 4px;
  background-color: #003333;
  color: #ffffff;
  border: none;
  border-radius: 18px;
  padding: 0 20px;
  font-weight: bold;
  cursor: pointer;
}

.email-input {
  width: 100%;
  padding: 12px 120px 12px 15px;
  border: 1px solid #ddd;
  border-radius: 18px;
  font-size: 16px;
  box-sizing: border-box;
}


.signup-button:hover {
  background-color: #003333;
}

.dialog-footer-btn {
  color: #fff;
  justify-content: center;
  /*white-space: normal; */
  align-items: center;
  border-radius: 5px;
  border: 3px solid #003333;
  background-color: #003333;
  width: 100%;
  font: 500 15px DINosaur-a, sans-serif;
  padding: 10px 0;
  height: max-content;
}
</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/steps/uConnectCheckUserDialog.vue